import type { FC } from "react"

import { useRecoilValue } from "recoil"

import { dragBoxState } from "../../state/inputs"

export const DragBox: FC = () => {
  const dragBox = useRecoilValue(dragBoxState)

  return dragBox ? (
    <rect
      x={dragBox.x}
      y={dragBox.y}
      width={dragBox.w}
      height={dragBox.h}
      fill="#08d3"
      stroke="#0ff"
    />
  ) : null
}
